import React from "react";
import{ Link } from "react-router-dom";
import './HomePage.css';
function HomePage() {
    return (
        <div className="homepage-container">
            <h1>Welcome to Hospital</h1>
            <Link to="/doctor-login">
            <button className="login-button">Doctor Login</button></Link>
        </div>
    );
}
export default HomePage;